import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactForm } from "@/components/support/ContactForm";
import { FAQ } from "@/components/support/FAQ";
import { Card } from "@/components/ui/card";
import { Mail, MessageCircle, Clock } from "lucide-react";

const Support = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="py-20">
        <div className="container px-4 max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              How Can We Help You?
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Find answers to common questions or get in touch with our support team.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <Card className="p-6 text-center">
              <div className="inline-flex p-4 bg-primary/10 rounded-full mb-4">
                <Mail className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-bold mb-2">Contact Form</h3>
              <p className="text-sm text-muted-foreground mb-3">
                Send us a message
              </p>
              <a 
                href="#contact"
                className="text-sm text-primary hover:underline"
              >
                Fill out the form
              </a>
            </Card>

            <Card className="p-6 text-center">
              <div className="inline-flex p-4 bg-primary/10 rounded-full mb-4">
                <MessageCircle className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-bold mb-2">Live Chat</h3>
              <p className="text-sm text-muted-foreground mb-3">
                Chat with our team
              </p>
              <p className="text-sm text-primary">
                Coming soon
              </p>
            </Card>

            <Card className="p-6 text-center">
              <div className="inline-flex p-4 bg-primary/10 rounded-full mb-4">
                <Clock className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-bold mb-2">Response Time</h3>
              <p className="text-sm text-muted-foreground mb-3">
                We typically respond within
              </p>
              <p className="text-sm font-semibold">24 hours</p>
            </Card>
          </div>

          {/* FAQ Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-2 text-center">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground text-center mb-8">
              Find quick answers to the most common questions about Email2Contact.
            </p>
            <div className="max-w-3xl mx-auto">
              <FAQ />
            </div>
          </div>

          {/* Contact Form Section */}
          <div id="contact" className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-2">
                Still Have Questions?
              </h2>
              <p className="text-muted-foreground">
                Send us a message and we'll get back to you as soon as possible.
              </p>
            </div>
            <ContactForm />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Support;
